// libraries
import React, { useState} from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ContactCardProps {
	image?: {
		src: string
		alt?: string
	}
	name?: string
	position?: string
	email?: {
		isVisible: boolean
		revealText: string
		email: string
	}
}

export default function ContactCard({
    image,
	name,
	position,
	email
}: ContactCardProps) {

	const [isRevealed, setIsRevealed] = useState(false)

    return (
		<div className='contact-card'>

			<div className={clsx(
				'contact-card__image',
				!image && 'contact-card__image--no-image'
			)}>
				{image && (
					<Image
						src={image.src} // 330x400
						alt={image.alt}
						className='cover'
					/>
				)}
			</div>

			<div className='contact-card__content text-md'>

				{isNonWhitespaceString(name) && (
					<p className='contact-card__content__name medium'>
						{name}
					</p>    
				)}

				{isNonWhitespaceString(position) && (
					<p className='contact-card__content__position'>
						{position}
					</p>
				)}

				{isNonWhitespaceString(email?.email) && (
					email.isVisible || isRevealed ? (
						<a href={'mailto:' + email.email} className='contact-card__content__email'>
							{email.email}
						</a>
					) : (
						<button
							className='contact-card__content__email'
							onClick={() => setIsRevealed(true)}
						>
							{email.revealText}
						</button>
					)   
				)}

			</div>

		</div>
	)
}